import { OpportunityType } from '@shared/models/opportunity';
import { PropertyDefinition } from '@shared/models/property-definition';
import { OpportunityRequirement } from '../modules/core/models/schema-property-definition';

/**
 * @deprecated use  OpportunityRequirement, OpportunitySchema from `schema-property-definition/opportunity`
 */
export function requiredForMode(
  requirement: OpportunityRequirement.ValueRequirement,
  mode: OpportunityRequirement.Mode,
  opportunityType: OpportunityType
): boolean {
  if (requirement.requirementType === 'Fundamental') {
    return true;
  }

  if (!requirement.requirements) {
    throw new Error('missing requirements property in `requirement`');
  }

  switch (mode) {
    case OpportunityRequirement.Mode.Recommendation:
      return (
        requirement.requirements.findIndex(
          (requirement) =>
            requirement.opportunityType === opportunityType &&
            requirement.requirement === 'Recommendation'
        ) >= 0
      );

    case OpportunityRequirement.Mode.Application:
      return (
        requirement.requirements.findIndex(
          (requirement) => requirement.opportunityType === opportunityType
        ) >= 0
      );
  }
}

/**
 * @deprecated use  OpportunityRequirement, OpportunitySchema from `schema-property-definition/opportunity`
 */
export type OpportunityPropertyDefinition<T> = PropertyDefinition<T> & {
  requirement: OpportunityRequirement.ValueRequirement | null;
};

/**
 * @deprecated use  OpportunityRequirement, OpportunitySchema from `schema-property-definition/opportunity`
 */
export function createOpportunityPropertyDefinition<T>(
  value?: T
): OpportunityPropertyDefinition<T> {
  return {
    value: value,
    requirement: null,
    options: undefined,
    range: undefined,
    initialValue: value,
    change: undefined
  };
}
